import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { debounceTime, distinctUntilChanged, Subject, switchMap } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { deactivated } from 'src/app/Models/deactivated';
import { ChangeRequestDetails, PendingChangeRequest, UserItem, UsersApiResponse, UsersResponseData, Vehicle, VehicleImage } from 'src/app/Models/Users';
import { ConfirmationServiceService } from 'src/app/Services/confirmation-service.service';
import { UsersService } from 'src/app/Services/users.service';
import { CustomToasterServiceService } from 'src/app/Services/custom-toaster-service.service';
import { guide } from 'src/app/Models/guide';
import { Booking, BookingCancellationReason, BookingDetailsOutput, CancellationDetails, ChatMessage } from 'src/app/Models/booking';
import { BookingComponent } from '../booking/booking.component';
import { BookingService } from 'src/app/Services/booking.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
})
export class UserComponent {
  totalPagesAll: number = 0;
  ApproveReq() {}
  RejectReq() {}
  RejectGuideReq() {}
  changeRequestDetailCanvas: any;
  selectedChangeRequestDetails: any;

  touristicon: boolean = true
  allusersvar: boolean = true
  touristvar: boolean = false
  tourvar: boolean = false
  Activated: boolean = true
  applicationvar: boolean = true
  previewImageUrl: string = '';
  allbookingarray: number[] = []
  BookingHistorytotalbookingpage = 0;
  pageSize = 10;
  AdminUserId: number = 0;
  toursection: boolean = true
  messagesection: boolean = false
  paymentsection: boolean = false
  totalUsers: number = 0
  totalPages: number = 0
  adminid: number = 0
  totalAll: number = 0
  userId = 0
  UserId: number | null = null;
  searchText: string = '';
  username: string = ''
  bookinghistory: boolean = false
  currentPage: number = 1;

  bookingHistoryTotalCount: number = 0
  viewMode = 'overview';
  BookingHistory: Booking[] | null = null;
  GuideVehicle: Vehicle | null = null;
  vehicleImages: VehicleImage[] = [];
  pages: number[] = [];

  guideVehicleViewMode: 'overview' | 'vehicleDetails' = 'overview';
  selectedGuideVehicle: Vehicle | null = null;
  guideVehicleImages: VehicleImage[] = [];
  guideVehicleIndex: number = 0;

  getVehicleImageUrl(vehicle: Vehicle | null | undefined, imageType?: string): string {
    if (!vehicle || !Array.isArray(vehicle.vehicleImages) || vehicle.vehicleImages.length === 0) {
      return '/assets/userIcon/car.svg';
    }

    if (imageType) {
      const typed = vehicle.vehicleImages.find(img => img.imageType === imageType);
      if (typed?.imageUrl) return typed.imageUrl;
    }

    const firstWithUrl = vehicle.vehicleImages.find(img => !!img.imageUrl);
    return firstWithUrl?.imageUrl || '/assets/userIcon/car.svg';
  }

  getVehicleImages(vehicle: Vehicle | null | undefined): VehicleImage[] {
    if (!vehicle || !Array.isArray(vehicle.vehicleImages)) return [];
    return vehicle.vehicleImages;
  }

  pageSizeAll: number = 10;
  pageSizeTourists: number = 10;
  pageSizeGuides: number = 10;
  pageSizeApproved: number = 10;
  rejection: boolean = false
  showtogle: boolean = false
  rectionarray: any[] = []
  @ViewChild('closeBtn') closeBtn!: ElementRef;
  @ViewChild('closeBtn2') closeBtn2!: ElementRef;

  windowtouristSize: number = 5; searchSubject = new Subject<string>();
  groupedReasons: { [key: string]: any[] } = {};


  bookingcanceldetails: CancellationDetails = {
    sendToEmail: '',
    reciversName: '',
    touristName: '',
    tourGuideName: '',
    tourstartDate: '',
    tourEndDate: '',
    tourDestination: '',
    bookingId: 0,
    cancelledByRole: '',
    cancelledOn: '',
    cancellationReason: ''
  };
  roleid: number = 0

  ngOnInit(): void {


    this.setupDebounceSearch();
    this.loadAllUsers();

    this.getguideAprove()
    // this.loadTourGuides();
    this.getreasonofreject()


    const storedData = sessionStorage.getItem('userData');
    if (storedData) {
      const parsedData = JSON.parse(storedData);

      this.adminid = parsedData.userId;
      this.username = parsedData.firstName
      this.searchSubject.pipe(
        debounceTime(500),
        distinctUntilChanged()
      ).subscribe(searchText => {
         
        if (this.getuserid.roleId == 2) { this.loadTouristBookingHistory(searchText); }
        else if (this.getuserid.roleId == 3) {
          this.loadGuideBookingHistory(searchText)
        }


      });

      this.loadTouristBookingHistory();

    }



  }



  onrejection() {
    this.rejection = true
  }

  backonform() {
    if (this.rejection) {
      this.rejection = false
    }
  }


  getRemainingDays(endDate: string): number {
    const today = new Date();
    const end = new Date(endDate);
    const diff = end.getTime() - today.getTime();
    return Math.max(0, Math.ceil(diff / (1000 * 3600 * 24)));
  }
  selectedStatus: string[] = ['Pending', 'Confirmed', 'InProgress', 'Completed', 'Cancelled'];

  selectedfilter: string = '';
  onStatusChange() {
    this.selectedStatus = this.selectedfilter ? [this.selectedfilter] : ['Pending', 'Confirmed', 'InProgress', 'Completed', 'Cancelled'];

    if (this.getuserid.roleId === 2) {
      this.loadTouristBookingHistory('');
    } else if (this.getuserid.roleId === 3) {
      this.loadGuideBookingHistory('');
    }
  }

  getStatusClass(status: string): string {
    switch (status.toLowerCase()) {
      case 'completed':
        return 'bookingstatus';
      case 'pending':
        return 'bookingstatuspending';
      case 'confirmed':
        return 'bookingstatusupcoming';
      case 'inprogress':
        return 'bookingstatusupcoming';
      case 'cancelled':
        return 'bookingstatuscanceled';
      default:
        return '';
    }
  }

  getStatusIcon(status: string): string {
    switch (status.toLowerCase()) {
      case 'completed':
        return 'assets/userIcon/CompletedIcon.svg';
      case 'pending':
        return '/assets/userIcon/pendingIcon.svg';
      case 'confirmed':
        return '/assets/userIcon/Upcomingicon.svg';
      case 'cancelled':
        return '/assets/userIcon/CancellIcon.svg';
      case 'inprogress':
        return '/assets/userIcon/inprogress.svg';
      default:
        return '';
    }
  }

  getuserid: UserItem = {
    userId: 0,
    firstName: '',
    lastName: '',
    profilePhotoUrl: '',
    gender: '',
    roleId: 0,
    email: '',
    avgRating: 0,
    createdAt: '',
    isDeactivate: false,
    displayName: '',
    tourGuideUserId: 0,
    tourGuideId: 0,
    imageUrl: '',
    vehicles: [],
    location: null,
    tourGuideGovIdUrl: null,
    govIdBackUrl: null,
    licenceImgUrl: null,
    licenceImgBackUrl: null,
    languages: [],
    dialCode: '',
    phoneNumber: '',
    country: '',
    countryCode: ''


  };


  getguide: Partial<guide> = {};



  private searchAll$ = new Subject<string>();
  private searchTourists$ = new Subject<string>();
  private searchGuides$ = new Subject<string>();
  private searchverifyGuides$ = new Subject<string>();
  private searchChangeRequests$ = new Subject<string>();
  private searchRejectedApps$ = new Subject<string>();


  currentPages: number = 1;
  minPage: number = 1;
  maxPage: number = 4;

  BookingHistorypageNumber: number = 1
  allUsers: any[] = [];
  tourists: any[] = [];
  tourGuides: any[] = [];
  guideapprove: guide[] = []
  activeTab: string = 'tour'; // default

  totalguidepage = 0
  pageAll = 1;
  pageTourists = 1;
  pageGuides = 1;

  totalTourists = 0
  totalPagesTourists = 0
  originalUserData: UserItem | null = null;
  totalguide = 0
  totalGuides = 0
  searchAll = '';
  searchTourists = '';
  searchGuides = '';
  BookinghistorypageSize: number = 10;
  searchguidetext: string = ''
  guidepage: number = 1
  guidepagesize: number = 10

  docnum: number = 1

  totalaprove: number = 0
  documentImages: { url: string; label: string }[] = [];

  private searchTextSubject = new Subject<string>();
  deactivated: Partial<deactivated> = {};
  guideuser: any = {};

  touristcollections: string[] = []
  guidecollections: string[] = []
  touristpages: number[] = []


  aproveuser: number[] = []
  totalaprovepage: number = 0
  totalaproveuser: number = 0

  changeRequests: PendingChangeRequest[] = [];
  totalChangeRequests: number = 0;
  totalChangeRequestPages: number = 0;
  changeRequestSearchText: string = '';
  changeRequestPage: number = 1;
  changeRequestPageSize: number = 10;
  changeRequestStatus: string = 'Approved'; // Default Status
  selectedChangeRequestUser: PendingChangeRequest | null = null;
  
  rejectedApplications: any[] = [];
  totalRejectedApps: number = 0;
  totalRejectedPages: number = 0;
  rejectedSearchText: string = '';
  rejectedPage: number = 1;
  rejectedPageSize: number = 10;
  
  unavailableDates: string[] = [];
  currentMonth: Date = new Date();
  calendarDays: any[] = [];
  weekDays: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  constructor(
    private userservice: UsersService,
    private confirmDialogService: ConfirmationServiceService,
    private toasterService: CustomToasterServiceService,
    private bookingservice: BookingService
  ) { }

  openPhotoPreview(url?: string | null) {
    this.previewImageUrl = url || 'assets/userIcon/user.png';
  }


  closeCanvas() {
    this.viewMode = 'overview'
  }

  userlength: number = 0

  getuserarr: UserItem[] = []
  jumpPageInput: number = 1;
  jumpPageInputt: number = 1;
  jumpPageInputg: number = 1;
  selectedTab: string = 'all'; // default
  applicationtab: boolean = false

  selectTab(tab: string) {
    this.selectedTab = tab;
    this.pageAll = 1;
    if (tab === 'all') {
      this.roleid = 0;
      this.loadAllUsers();
    } else if (tab === 'tourist') {
      this.roleid = 2;
      this.loadAllUsers();
    } else if (tab === 'tour') {
      this.roleid = 3;
      this.loadAllUsers();
    } else if (tab === 'Application') {
      this.getguideAprove();
    } else if (tab === 'ChangeRequest') {
      this.getChangeRequests();
    } else if (tab === 'RejectedApplication') {
      this.getRejectedApplications();
    }
  }
  selectguideTabs: string = 'overview';
  selectguideTab(tab: string) {
    this.selectguideTabs = tab;


    if (tab === 'overview') {

    } else if (tab === 'verifaication') {

    }

  }










  next() {
    if (this.docnum < 3) {
      this.docnum++
    }

  }

  previous() {
    if (this.docnum > 1) {
      this.docnum--
    }

  }


  onSearch(type: 'all' | 'tourists' | 'guides' | 'verifyguide' | 'changerequests' | 'rejectedapps', value: string) {
    if (type === 'all') this.searchAll$.next(value);
    if (type === 'tourists') this.searchTourists$.next(value);
    if (type === 'guides') this.searchGuides$.next(value);
    if (type === 'verifyguide') this.searchverifyGuides$.next(value);
    if (type === 'changerequests') this.searchChangeRequests$.next(value);
    if (type === 'rejectedapps') this.searchRejectedApps$.next(value);
  }

  selectedTabs: string = 'overview';

  setupDebounceSearch() {
    this.searchAll$.pipe(debounceTime(1000)).subscribe(value => {
      this.searchAll = value;
      this.pageAll = 1;
      this.loadAllUsers();
    });

    this.searchTourists$.pipe(debounceTime(500)).subscribe(value => {
      this.searchTourists = value;
      this.pageTourists = 1;

    });

    this.searchGuides$.pipe(debounceTime(500)).subscribe(value => {
      this.searchGuides = value;
      this.pageGuides = 1;
      // this.loadTourGuides();
    });
    this.searchverifyGuides$.pipe(debounceTime(500)).subscribe(value => {
      this.searchguidetext = value;
      this.pageGuides = 1;
      this.getguideAprove();
    })
    
    this.searchChangeRequests$.pipe(debounceTime(500)).subscribe(value => {
      this.changeRequestSearchText = value;
      this.changeRequestPage = 1;
      this.getChangeRequests();
    });

    this.searchRejectedApps$.pipe(debounceTime(500)).subscribe(value => {
      this.rejectedSearchText = value;
      this.rejectedPage = 1;
      this.getRejectedApplications();
    });
  }




  onSearchInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchSubject.next(input.value);
  }





  goToPages(pageNumber: number): void {
     
    if (pageNumber >= 1 && pageNumber <= this.BookingHistorytotalbookingpage) {
      this.BookingHistorypageNumber = pageNumber;

      if (this.getuserid.roleId == 2) {
        this.loadTouristBookingHistory()
      }
      else if (this.getuserid.roleId == 3) {
        this.loadGuideBookingHistory()
      }


    }
  }




  gettouristvar() {
    this.allusersvar = false
    this.touristvar = true
    this.tourvar = false
  }

  gettour() {
    this.allusersvar = false,
      this.touristvar = false,
      this.tourvar = true
  }

  alluser() {
    this.allusersvar = true
    this.touristvar = false
    this.tourvar = false
  }


  messageturns() {
    this.toursection = false
    this.paymentsection = false
    this.messagesection = true
  }
  tourturns() {
    this.toursection = true
    this.paymentsection = false
    this.messagesection = false
  }
  paymentturns() {
    this.toursection = false
    this.paymentsection = true
    this.messagesection = false
  }


  filterrecord() {
    this.Activated = !this.Activated
  }


  openUserProfile(user: UserItem) {
     
    this.getuserid = JSON.parse(JSON.stringify(user));
    this.originalUserData = JSON.parse(JSON.stringify(user));

    this.viewMode = 'overview';
    this.GuideVehicle = null;
  }
  resetAllFields() {
    this.getuserid = JSON.parse(JSON.stringify(this.originalUserData));
    this.editFields = {};
    this.Togleswitch();
  }

  openGuideProfile(guide: guide) {
     
    this.guideuser = { ...guide };
    this.buildImageList();
    this.selectguideTabs = 'overview';
    this.guideVehicleViewMode = 'overview';
    this.selectedGuideVehicle = this.guideuser?.vehicles ? (this.guideuser.vehicles[0] || null) : null;
    this.guideVehicleImages = this.selectedGuideVehicle ? (this.selectedGuideVehicle.vehicleImages || []) : [];
    this.guideVehicleIndex = 0;

  }

  toggleGuideVehicleView(view: 'overview' | 'vehicleDetails') {
    this.guideVehicleViewMode = view;
    this.selectedGuideVehicle = this.guideuser?.vehicles ? (this.guideuser.vehicles[0] || null) : null;
    this.guideVehicleImages = this.selectedGuideVehicle ? (this.selectedGuideVehicle.vehicleImages || []) : [];
    this.guideVehicleIndex = 0;
  }

  guidePreviousVehicleImage(): void {
    if (this.guideVehicleIndex > 0) {
      this.guideVehicleIndex--;
    }
  }

  guideNextVehicleImage(): void {
    if (this.guideVehicleIndex < this.guideVehicleImages.length - 1) {
      this.guideVehicleIndex++;
    }
  }
  buildImageList() {
     
    const sources = [
      { key: 'tourGuideGovIdUrl', label: 'National ID Front' },
      { key: 'govIdBackUrl', label: 'National ID Back' },
      { key: 'licenceImgUrl', label: 'Licence Front' },
      { key: 'licenceImgBackUrl', label: 'Licence Back' },
    ];

    this.documentImages = sources
      .filter(doc => !!this.guideuser[doc.key])
      .map(doc => ({
        url: this.guideuser[doc.key],
        label: doc.label
      }));


    if (this.documentImages.length === 0) {
      this.documentImages.push({
        url: '/assets/userIcon/doc.png',
        label: 'No Document Available'
      });
    }



  }

  buildUserDocumentList() {
    const sources = [
      { key: 'tourGuideGovIdUrl', label: 'National ID Front' },
      { key: 'govIdBackUrl', label: 'National ID Back' },
      { key: 'licenceImgUrl', label: 'Licence Front' },
      { key: 'licenceImgBackUrl', label: 'Licence Back' },
    ];

    // Check if getuserid has the properties, otherwise cast to any or check type definition
    const user = this.getuserid as any;

    this.documentImages = sources
      .filter(doc => !!user[doc.key])
      .map(doc => ({
        url: user[doc.key],
        label: doc.label
      }));

    if (this.documentImages.length === 0) {
      this.documentImages.push({
        url: '/assets/userIcon/doc.png',
        label: 'No Document Available'
      });
    }
  }

  toggleView(view: 'overview' | 'history' | 'payout' | 'vehicleDetails' | 'documents' | 'unavailability') {
    this.viewMode = view;
     
    if (view == 'history') {
      if (this.getuserid.roleId == 2) {
        this.loadTouristBookingHistory()
      }
      else if (this.getuserid.roleId == 3) {
        this.loadGuideBookingHistory()

      }
    }
    if (view == 'payout' || view == 'vehicleDetails') {
      this.GuideVehicle = this.getuserid.vehicles ? this.getuserid.vehicles[0] || null : null;
      this.vehicleImages = this.GuideVehicle ? this.GuideVehicle.vehicleImages : [];
      this.currentIndex = 0; // Reset index for vehicle images
    }
    if (view == 'documents') {
      this.buildUserDocumentList();
      this.currentIndex = 0; // Reset index for document images
    }
    if (view === 'unavailability') {
      this.currentMonth = new Date(); // Reset to today
      this.loadUnavailableDates();
    }

  }
  getFrontImageUrl(): string {
    const frontImage = this.vehicleImages.find(img => img.imageType === 'Front');
    return frontImage ? frontImage.imageUrl : '/assets/userIcon/car.svg';
  }
  previousImage(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  nextImage(): void {
    if (this.currentIndex < this.vehicleImages.length - 1) {
      this.currentIndex++;
    }
  }

  isEditingVehicle: boolean = false;
  editVehicleData: any = {};
  editVehicleFiles: File[] = [];
  editVehicleImagePreviews: { url: string, type: string }[] = [];
  isSavingVehicle: boolean = false;

  startEditVehicle() {
    this.isEditingVehicle = true;
    if (this.GuideVehicle) {
      this.editVehicleData = {
        vehicleBrandName: this.GuideVehicle.vehicleBrandName,
        vehicleModelName: this.GuideVehicle.vehicleModelName,
        licensePlateNumber: this.GuideVehicle.licensePlateNumber,
        noOfSeats: this.GuideVehicle.noOfSeats,
        noOfDoors: this.GuideVehicle.noOfDoors,
        hourlyRate: this.GuideVehicle.hourlyRate,
        isAirConditioner: this.GuideVehicle.isAirConditioner,
        noOfLargeBags: this.GuideVehicle.noOfLargeBags || 0,
        noOfSmallBags: this.GuideVehicle.noOfSmallBags || 0
      };
    } else {
      this.editVehicleData = {};
    }
    this.editVehicleFiles = [];
    this.editVehicleImagePreviews = [];
  }

  cancelEditVehicle() {
    this.isEditingVehicle = false;
    this.editVehicleFiles = [];
    this.editVehicleImagePreviews = [];
  }

  onVehicleFilesSelected(event: any) {
    if (event.target.files) {
      const newFiles = Array.from(event.target.files as FileList) as File[];
      this.editVehicleFiles = [...this.editVehicleFiles, ...newFiles].slice(0, 5); // Max 5 images appended
      this.generatePreviews();
      // Reset input value to allow selecting the same file again if needed
      event.target.value = '';
    }
  }

  generatePreviews() {
    this.editVehicleImagePreviews = [];
    const imageTypes = ["Front", "Rear", "Left", "Right", "Interior"];
    
    this.editVehicleFiles.forEach((file, index) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        // Need to insert at correct index because FileReader is async
        this.editVehicleImagePreviews[index] = {
          url: e.target.result,
          type: imageTypes[index] || `Image ${index + 1}`
        };
      };
      reader.readAsDataURL(file);
    });
  }

  removeEditVehicleImage(index: number) {
    this.editVehicleFiles.splice(index, 1);
    this.generatePreviews();
  }

  saveVehicleDetails() {
    if (!this.getuserid || !this.getuserid.tourGuideId) return;

    this.isSavingVehicle = true;

    const finalize = () => {
      this.isSavingVehicle = false;
      this.isEditingVehicle = false;
      this.toasterService.success('Vehicle updated successfully!');
      
      // Update local object to reflect changes without a full refetch if not necessary
      if (this.GuideVehicle) {
        this.GuideVehicle.vehicleBrandName = this.editVehicleData.vehicleBrandName;
        this.GuideVehicle.vehicleModelName = this.editVehicleData.vehicleModelName;
        this.GuideVehicle.licensePlateNumber = this.editVehicleData.licensePlateNumber;
        this.GuideVehicle.noOfSeats = this.editVehicleData.noOfSeats;
        this.GuideVehicle.noOfDoors = this.editVehicleData.noOfDoors;
        this.GuideVehicle.hourlyRate = this.editVehicleData.hourlyRate;
        this.GuideVehicle.isAirConditioner = this.editVehicleData.isAirConditioner;
        this.GuideVehicle.noOfLargeBags = this.editVehicleData.noOfLargeBags;
        this.GuideVehicle.noOfSmallBags = this.editVehicleData.noOfSmallBags;

        // Instant image refresh manually
        if (this.editVehicleImagePreviews && this.editVehicleImagePreviews.length > 0) {
          this.editVehicleImagePreviews.forEach((preview, idx) => {
            if (this.vehicleImages[idx]) {
              this.vehicleImages[idx].imageUrl = preview.url;
              this.vehicleImages[idx].imageType = preview.type;
            } else {
              this.vehicleImages.push({
                vehicleImageId: 0,
                imageType: preview.type,
                imageUrl: preview.url
              });
            }
          });
          this.GuideVehicle.vehicleImages = [...this.vehicleImages];
        }
      }
      this.loadAllUsers(); 
    };

    const formData = new FormData();
    const vehicleId = this.GuideVehicle?.vehicleId || 0;
    
    formData.append('VehicleId', vehicleId.toString());
    if (this.editVehicleData.vehicleBrandName) formData.append('VehicleBrandName', this.editVehicleData.vehicleBrandName);
    if (this.editVehicleData.vehicleModelName) formData.append('VehicleModelName', this.editVehicleData.vehicleModelName);
    if (this.editVehicleData.licensePlateNumber) formData.append('LicensePlateNumber', this.editVehicleData.licensePlateNumber);
    if (this.editVehicleData.noOfDoors) formData.append('NoOfDoors', this.editVehicleData.noOfDoors.toString());
    if (this.editVehicleData.noOfSeats) formData.append('NoOfSeats', this.editVehicleData.noOfSeats.toString());
    if (this.editVehicleData.noOfLargeBags !== undefined) formData.append('NoOfLargeBags', this.editVehicleData.noOfLargeBags.toString());
    if (this.editVehicleData.noOfSmallBags !== undefined) formData.append('NoOfSmallBags', this.editVehicleData.noOfSmallBags.toString());
    formData.append('IsAirConditioner', this.editVehicleData.isAirConditioner ? 'true' : 'false');
    
    // Append all selected images
    this.editVehicleFiles.forEach(file => {
      formData.append('files', file);
    });

    const ratePayload = {
      tourguideId: this.getuserid.tourGuideId,
      vehicleId: vehicleId,
      tourGuideCharges: this.editVehicleData.hourlyRate || 0
    };

    // Sequential update
    this.userservice.updateVehicleAdmin(formData).subscribe({
      next: () => {
         this.userservice.upsertTourguideCharge(ratePayload).subscribe({
            next: () => { finalize(); },
            error: (err) => { 
                this.isSavingVehicle = false; 
                this.toasterService.error('Vehicle details saved, but rate update failed.');
            }
         });
      },
      error: (err) => {
         this.isSavingVehicle = false;
         this.toasterService.error('Failed to update vehicle details.');
      }
    });

  }

  isEditingDocuments: boolean = false;
  editDocumentGovIdType: string = '';
  editDocumentGovIdFile: File | null = null;
  editDocumentGovIdBackFile: File | null = null;
  editDocumentLicenceFile: File | null = null;
  editDocumentLicenceBackFile: File | null = null;
  editDocumentGovIdPreview: string = '';
  editDocumentGovIdBackPreview: string = '';
  editDocumentLicencePreview: string = '';
  editDocumentLicenceBackPreview: string = '';
  isSavingDocuments: boolean = false;

  startEditDocuments() {
    this.isEditingDocuments = true;
    this.editDocumentGovIdType = this.getuserid?.tourGuideGovIdUrl ? 'National ID' : ''; // Or pull from somewhere if stored
    this.editDocumentGovIdFile = null;
    this.editDocumentGovIdBackFile = null;
    this.editDocumentLicenceFile = null;
    this.editDocumentLicenceBackFile = null;
    this.editDocumentGovIdPreview = '';
    this.editDocumentGovIdBackPreview = '';
    this.editDocumentLicencePreview = '';
    this.editDocumentLicenceBackPreview = '';
  }

  cancelEditDocuments() {
    this.isEditingDocuments = false;
    this.editDocumentGovIdFile = null;
    this.editDocumentGovIdBackFile = null;
    this.editDocumentLicenceFile = null;
    this.editDocumentLicenceBackFile = null;
    this.editDocumentGovIdPreview = '';
    this.editDocumentGovIdBackPreview = '';
    this.editDocumentLicencePreview = '';
    this.editDocumentLicenceBackPreview = '';
  }

  onGovIdFileSelected(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.editDocumentGovIdFile = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.editDocumentGovIdPreview = e.target.result;
      };
      reader.readAsDataURL(this.editDocumentGovIdFile as Blob);
      event.target.value = '';
    }
  }

  onGovIdBackFileSelected(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.editDocumentGovIdBackFile = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.editDocumentGovIdBackPreview = e.target.result;
      };
      reader.readAsDataURL(this.editDocumentGovIdBackFile as Blob);
      event.target.value = '';
    }
  }

  onLicenceFileSelected(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.editDocumentLicenceFile = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.editDocumentLicencePreview = e.target.result;
      };
      reader.readAsDataURL(this.editDocumentLicenceFile as Blob);
      event.target.value = '';
    }
  }

  onLicenceBackFileSelected(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.editDocumentLicenceBackFile = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.editDocumentLicenceBackPreview = e.target.result;
      };
      reader.readAsDataURL(this.editDocumentLicenceBackFile as Blob);
      event.target.value = '';
    }
  }

  removeGovIdPreview() {
    this.editDocumentGovIdFile = null;
    this.editDocumentGovIdPreview = '';
  }

  removeGovIdBackPreview() {
    this.editDocumentGovIdBackFile = null;
    this.editDocumentGovIdBackPreview = '';
  }

  removeLicencePreview() {
    this.editDocumentLicenceFile = null;
    this.editDocumentLicencePreview = '';
  }

  removeLicenceBackPreview() {
    this.editDocumentLicenceBackFile = null;
    this.editDocumentLicenceBackPreview = '';
  }

  saveDocumentDetails() {
    if (!this.getuserid || !this.getuserid.userId) return;

    this.isSavingDocuments = true;
    const formData = new FormData();
    formData.append('UserId', this.getuserid.userId.toString());
    
    if (this.editDocumentGovIdType) formData.append('TourGuideGovIdType', this.editDocumentGovIdType);
    if (this.editDocumentGovIdFile) formData.append('GovIdFrontImage', this.editDocumentGovIdFile);
    if (this.editDocumentGovIdBackFile) formData.append('GovIdBackImage', this.editDocumentGovIdBackFile);
    if (this.editDocumentLicenceFile) formData.append('LicenceFrontImage', this.editDocumentLicenceFile);
    if (this.editDocumentLicenceBackFile) formData.append('LicenceBackImage', this.editDocumentLicenceBackFile);

    this.userservice.updateTourguideDocuments(formData).subscribe({
      next: () => {
         this.isSavingDocuments = false;
         this.isEditingDocuments = false;
         
         // Manually refresh document images natively
         if (this.editDocumentGovIdPreview) {
           this.getuserid.tourGuideGovIdUrl = this.editDocumentGovIdPreview;
         }
         if (this.editDocumentGovIdBackPreview) {
           this.getuserid.govIdBackUrl = this.editDocumentGovIdBackPreview;
         }
         if (this.editDocumentLicencePreview) {
           this.getuserid.licenceImgUrl = this.editDocumentLicencePreview;
         }
         if (this.editDocumentLicenceBackPreview) {
           this.getuserid.licenceImgBackUrl = this.editDocumentLicenceBackPreview;
         }
         this.buildUserDocumentList();
         
         this.toasterService.success('Documents updated successfully!');
         this.loadAllUsers(); 
      },
      error: (err) => {
         this.isSavingDocuments = false;
         this.toasterService.error('Failed to update documents.');
      }
    });

  }

  currentIndex: number = 0;

  showNext() {
    if (this.documentImages.length === 0) return;
    this.currentIndex = (this.currentIndex + 1) % this.documentImages.length;
  }

  showPrevious() {
    if (this.documentImages.length === 0) return;
    this.currentIndex =
      (this.currentIndex - 1 + this.documentImages.length) % this.documentImages.length;
  }

  loadUnavailableDates() {
    if (this.getuserid?.tourGuideId > 0) {
      this.userservice.getTourGuideUnavailability(this.getuserid.tourGuideId).subscribe({
        next: (res) => {
          if (res.isSuccess && res.data) {
            this.unavailableDates = res.data.map((d: string) => d.split('T')[0]);
          } else {
             this.unavailableDates = [];
          }
          this.generateCalendar();
        },
        error: (err) => {
          console.error('Failed to load unavailable dates', err);
          this.unavailableDates = [];
          this.generateCalendar();
        }
      });
    }
  }

  generateCalendar() {
    this.calendarDays = [];
    const year = this.currentMonth.getFullYear();
    const month = this.currentMonth.getMonth();
    
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    
    const startDate = new Date(firstDay);
    startDate.setDate(startDate.getDate() - startDate.getDay()); // Go back to Sunday
    
    const endDate = new Date(lastDay);
    if (endDate.getDay() !== 6) {
      endDate.setDate(endDate.getDate() + (6 - endDate.getDay())); // Go forward to Saturday
    }

    const today = new Date();
    today.setHours(0,0,0,0);

    let currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      const dateStr = this.formatDate(currentDate);
      const isPast = currentDate < today;

      this.calendarDays.push({
        date: new Date(currentDate),
        dateString: dateStr,
        dayNumber: currentDate.getDate(),
        isCurrentMonth: currentDate.getMonth() === month,
        isPast: isPast,
        isUnavailable: this.unavailableDates.includes(dateStr)
      });
      currentDate.setDate(currentDate.getDate() + 1);
    }
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  prevMonth() {
    this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() - 1, 1);
    this.generateCalendar();
  }

  nextMonth() {
    this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 1);
    this.generateCalendar();
  }

  toggleUnavailableDate(day: any) {
    if (day.isPast) {
      return; // Block past dates
    }

    if (day.isUnavailable) {
      // Remove
      this.unavailableDates = this.unavailableDates.filter(d => d !== day.dateString);
      day.isUnavailable = false;
    } else {
      // Add
      this.unavailableDates.push(day.dateString);
      day.isUnavailable = true;
    }
  }

  saveUnavailableDates() {
    if (this.getuserid?.tourGuideId > 0) {
      const payloadDates = this.unavailableDates.map(d => {
        const fullDate = new Date(d);
        fullDate.setUTCHours(0,0,0,0);
        return fullDate.toISOString();
      });
      
      const payload = {
        tourGuideId: this.getuserid.tourGuideId,
        dates: payloadDates
      };

      this.userservice.updateTourGuideUnavailability(payload).subscribe({
        next: (res) => {
          this.toasterService.success('Unavailable dates updated successfully.');
        },
        error: (err) => {
          this.toasterService.error('Failed to update unavailable dates.');
        }
      });
    }
  }
  
  loadTouristBookingHistory(searchText: string = '') {
     ;

    if (this.getuserid.userId > 0) {

      const bookingStatuses: string[] = Array.isArray(this.selectedStatus)
        ? this.selectedStatus
        : this.selectedStatus ? [this.selectedStatus] : [];

      this.userservice.getTouristBookingHistory(
        this.getuserid.userId,
        this.BookingHistorypageNumber,
        this.BookinghistorypageSize,
        searchText,
        bookingStatuses
      ).subscribe((res) => {
        this.BookingHistory = res.items;
        this.bookingHistoryTotalCount = res.totalCount;
        this.BookingHistorytotalbookingpage = Math.ceil(this.bookingHistoryTotalCount / this.BookinghistorypageSize);
        this.allbookingarray = Array.from({ length: this.bookingHistoryTotalCount }, (_, i) => i + 1);
      });
    } else {
      return;
    }
  }

  loadGuideBookingHistory(searchText: string = '') {
    if (this.getuserid.userId > 0) {
      const tourGuideUserId = this.getuserid.userId;


      const bookingStatuses: string[] = Array.isArray(this.selectedStatus)
        ? this.selectedStatus
        : this.selectedStatus ? [this.selectedStatus] : [];

      this.userservice.getGuideBookingHistory(
        tourGuideUserId,
        this.BookingHistorypageNumber,
        this.BookinghistorypageSize,
        searchText,
        bookingStatuses
      ).subscribe((res) => {
        this.BookingHistory = res.items;
        this.bookingHistoryTotalCount = res.totalCount;
        this.BookingHistorytotalbookingpage = Math.ceil(this.bookingHistoryTotalCount / this.BookinghistorypageSize);
        this.allbookingarray = Array.from({ length: this.BookingHistorytotalbookingpage }, (_, i) => i + 1);
      });
    } else {
      return;
    }

     ;
  }



  guidepages: number[] = []







  ApproveGuideReq() {
    this.confirmDialogService.openConfirmDialog('You are about to reactivate this tour guide’s account. Once activated, the guide will regain full access to all platform features including login, booking management, and earnings dashboard.', () => {
      this.userservice.ApproveTouGuideReq(this.guideuser.tourGuideId, this.adminid).subscribe((res) => {
        this.toasterService.success("Tour Guide Approved Successfully");
        this.sendWelcomeEmail();
        this.getguideAprove()
        this.closeBtn.nativeElement.click();
      });
    }, '/assets/userIcon/Active.png');
  }

  sendWelcomeEmail() {

    this.userservice.SendWelcomeEmail(this.guideuser.email, this.guideuser.firstName, this.guideuser.tourGuideId).subscribe((res) => {

      this.toasterService.success("Welcome Email Sent Successfully");
    }, (error) => {

      this.toasterService.error("Failed to send welcome email");
    });
  }


  goToallPage(pageNumber: number | string): void {

    if (typeof pageNumber !== 'number') return;

    if (pageNumber >= 1 && pageNumber <= this.totalPages) {
      this.pageAll = pageNumber;
      this.loadAllUsers();

    }
  }



  onSizeChanges(newSize: number): void {
    this.pageSize = newSize;
    this.pageAll = 1;
    this.loadAllUsers();
  }



  goToPage(pageNumber: number): void {

    if (typeof pageNumber !== 'number') return;
    if (pageNumber >= 1 && pageNumber <= this.totalPagesTourists) {
      this.pageTourists = pageNumber;

    }
  }


  touristonSizeChanges(newSize: number): void {
    this.pageSizeTourists = newSize;
    this.pageTourists = 1;

  }



  goToHistoryPages(pageNumber: number): void {
     
    if (pageNumber >= 1 && pageNumber <= this.BookingHistorytotalbookingpage) {
      this.BookingHistorypageNumber = pageNumber;
      if (this.getuserid.roleId === 2) {
        this.loadTouristBookingHistory('');
      } else if (this.getuserid.roleId === 3) {
        this.loadGuideBookingHistory('');
      }
    }
  }

  onHistorySizeChanges(newSize: number): void {
     
    this.BookinghistorypageSize = newSize;
    this.BookingHistorypageNumber = 1;
    if (this.getuserid.roleId === 2) {
      this.loadTouristBookingHistory('');
    } else if (this.getuserid.roleId === 3) {
      this.loadGuideBookingHistory('');
    }
  }


  approvegoToPage(pageNumber: number): void {
    if (typeof pageNumber !== 'number') return;
    if (pageNumber >= 1 && pageNumber <= this.totalaprovepage) {
      this.guidepage = pageNumber;
      this.getguideAprove();
    }
  }

  aproveonSizeChanges(newSize: number): void {
    this.pageSizeApproved = newSize;
    this.guidepage = 1;
    this.getguideAprove();
  }




  getguideAprove(): void {
    this.userservice.gettourguide(this.searchguidetext, this.guidepage, this.pageSizeApproved).subscribe((res) => {
      this.guideapprove = res.data.items;
      this.totalaproveuser = res.data.totalCount;
      this.totalaprovepage = Math.ceil(this.totalaproveuser / this.pageSize);
      this.aproveuser = Array.from({ length: this.totalaprovepage }, (_, i) => i + 1);


    });
  }

  getRejectedApplications(): void {
    this.userservice.getRejectedApplications(this.rejectedSearchText, this.rejectedPage, this.rejectedPageSize).subscribe((res) => {
      if(res && res.data) {
        this.rejectedApplications = res.data.items || [];
        this.totalRejectedApps = res.data.totalCount || 0;
        this.totalRejectedPages = Math.ceil(this.totalRejectedApps / this.rejectedPageSize);
      }
    });
  }

  onRejectedPageChange(pageNumber: number): void {
    if (typeof pageNumber !== 'number') return;
    if (pageNumber >= 1 && pageNumber <= this.totalRejectedPages) {
      this.rejectedPage = pageNumber;
      this.getRejectedApplications();
    }
  }

  onRejectedSizeChange(newSize: number): void {
    this.rejectedPageSize = newSize;
    this.rejectedPage = 1;
    this.getRejectedApplications();
  }

  getChangeRequests(): void {
    this.userservice.getPendingChangeRequests(this.changeRequestPage, this.changeRequestPageSize, this.changeRequestSearchText, this.changeRequestStatus).subscribe((res) => {
      if(res && res.data) {
        this.changeRequests = res.data.data || [];
        this.totalChangeRequests = res.data.totalRecords || 0;
        this.totalChangeRequestPages = Math.ceil(this.totalChangeRequests / this.changeRequestPageSize);
      }
    });
  }

  onChangeRequestsPage(pageNumber: number): void {
    if (typeof pageNumber !== 'number') return;
    if (pageNumber >= 1 && pageNumber <= this.totalChangeRequestPages) {
      this.changeRequestPage = pageNumber;
      this.getChangeRequests();
    }
  }

  onChangeRequestsSize(newSize: number): void {
    this.changeRequestPageSize = newSize;
    this.changeRequestPage = 1;
    this.getChangeRequests();
  }

  onChangeRequestStatus(): void {
    this.changeRequestPage = 1;
    this.getChangeRequests();
  }

  openChangeRequest(item: PendingChangeRequest): void {
    this.selectedChangeRequestUser = item;
    this.selectedChangeRequestDetails = null; // Clear old data while fetching
    this.userservice.getChangeRequestDetails(item.requestGroupId).subscribe((res) => {
      if (res && res.data) {
        this.selectedChangeRequestDetails = res.data;
      } else {
        this.toasterService.error("Failed to load details or no changes found.");
      }
    }, (error) => {
      this.toasterService.error("Error loading change request details.");
    });
  }

  @ViewChild('closeRejectModalBtn') closeRejectModalBtn!: ElementRef;
  selectedEntityForRejection: string = '';
  rejectionReason: string = '';

  approveChangeRequest(entity: string) {
    if (!this.selectedChangeRequestDetails || !this.selectedChangeRequestUser) return;
    const payload = {
      requestGroupId: this.selectedChangeRequestDetails.requestGroupId,
      entity: entity,
      action: "Approve",
      adminRemarks: null,
      email: this.selectedChangeRequestUser.email,
      tourGuideName: this.selectedChangeRequestUser.fullName
    };

    this.userservice.changeRequestAction(payload).subscribe({
      next: (res) => {
        this.toasterService.success(`${entity} details approved successfully.`);
        if (this.selectedChangeRequestUser) {
          this.openChangeRequest(this.selectedChangeRequestUser);
        }
      },
      error: (err) => {
        this.toasterService.error(`Failed to approve ${entity} details.`);
      }
    });
  }

  openRejectModal(entity: string) {
    this.selectedEntityForRejection = entity;
    this.rejectionReason = '';
  }

  submitRejection() {
    if (!this.rejectionReason || this.rejectionReason.trim() === '') {
      this.toasterService.error("Rejection reason is mandatory");
      return;
    }
    
    if (!this.selectedChangeRequestDetails || !this.selectedChangeRequestUser) return;

    const payload = {
      requestGroupId: this.selectedChangeRequestDetails.requestGroupId,
      entity: this.selectedEntityForRejection,
      action: "Rejected",
      adminRemarks: this.rejectionReason.trim(),
      email: this.selectedChangeRequestUser.email,
      tourGuideName: this.selectedChangeRequestUser.fullName
    };

    this.userservice.changeRequestAction(payload).subscribe({
      next: (res) => {
        this.toasterService.success(`${this.selectedEntityForRejection} details rejected successfully.`);
        if (this.closeRejectModalBtn) {
          this.closeRejectModalBtn.nativeElement.click();
        }
        if (this.selectedChangeRequestUser) {
          this.openChangeRequest(this.selectedChangeRequestUser);
        }
      },
      error: (err) => {
        this.toasterService.error(`Failed to reject ${this.selectedEntityForRejection} details.`);
      }
    });
  }




  Deactivateduser(userId: number) {
    this.confirmDialogService.openConfirmDialog('You are about to deactivate this tour guide’s account. Once deactivated, the guide will not be able to log in, accept bookings, or access any platform features.?', () => {
      this.userservice.DeactivatedUser(userId, this.adminid).subscribe((res) => {

        this.toasterService.success("User Deactivated Successfully");
        this.loadAllUsers();
        if (this.getuserid && this.getuserid.userId === userId) {
          this.getuserid.isDeactivate = true;
        }

      });
    }, '/assets/userIcon/deactivate.png'
    );
  }

  Activateduser(userId: number) {
    this.confirmDialogService.openConfirmDialog('You are about to activate this user’s account. Once activated, the user will regain full access to all platform features.', () => {
      this.userservice.ActivatedUser(userId, this.adminid).subscribe((res) => {

        this.toasterService.success("User Activated Successfully");
        this.loadAllUsers();
        if (this.getuserid && this.getuserid.userId === userId) {
          this.getuserid.isDeactivate = false;
        }

      });
    }, '/assets/userIcon/Active.png'
    );
  }




  jumpToPage(): void {
    if (this.jumpPageInput >= 1 && this.jumpPageInput <= this.totalPages) {
      this.pageAll = this.jumpPageInput;
      this.loadAllUsers();
    } else {
      alert(`Enter a page number between 1 and ${this.totalPages}`);
    }
  }




  uniqueSections: string[] = [];
  selectedReasonIds: number[] = [];
  selectedReasons: string[] = [];
  othermsg: string = ''

  toggleReason(reasonId: number, reasonText: string, event: any) {
    if (event.target.checked) {
      if (!this.selectedReasonIds.includes(reasonId)) {
        this.selectedReasonIds.push(reasonId);
        this.selectedReasons.push(reasonText);
      }
    } else {
      this.selectedReasonIds = this.selectedReasonIds.filter(id => id !== reasonId);
      this.selectedReasons = this.selectedReasons.filter(text => text !== reasonText);
    }
  }

  getreasonofreject() {
    this.userservice.getreasonforreject().subscribe((res) => {

      this.rectionarray = res
      this.uniqueSections = Array.from(new Set(this.rectionarray.map(r => r.sectionName)));


    })
  }
  rejectapplication() {
     
    this.confirmDialogService.openConfirmDialog('Are you sure you want to reject this application?This will notify the applicant by email with the selected reason. The applicant must log in and resubmit the application after correcting the issues mentioned in the email.', () => {
      if (this.selectedReasonIds.length === 0) {
        this.toasterService.error("Please Select Reason")
        return;
      }
      this.userservice.rejectbookingbyadmin(this.guideuser.tourGuideId, this.selectedReasonIds, this.adminid, this.othermsg).subscribe((res) => {
        this.rejectmail()
        this.getguideAprove()
        this.toasterService.success("Tour Guide Request Rejected Successfully");
        this.selectedReasonIds = []
        this.selectedReasons = []

      })
    }, '/assets/userIcon/rejectapp.png')
  }

  rejectmail() {
     
    const reasonsStr = this.selectedReasons.join(', ');
    this.userservice.sendrejectmail(this.guideuser.email, this.guideuser.firstName, reasonsStr, this.othermsg).subscribe((res) => {

      this.closeBtn.nativeElement.click();

    })
  }






  chatHistory: ChatMessage[] = [];
  SelectededtouristUserId: number | null = null

  selectedBooking: Booking | null = null;

  SelectedtourGuideUserId: number | null = null


  getresonofcancel: BookingCancellationReason[] = []





  getRemainingDayss(endDate: string): number {
    const today = new Date();
    const end = new Date(endDate);
    const diff = end.getTime() - today.getTime();
    return Math.max(0, Math.ceil(diff / (1000 * 3600 * 24)));
  }






  messageturnss(selectedBooking: Booking | null) {
     

    if (selectedBooking) {

      this.SelectededtouristUserId = selectedBooking.userId;
      this.SelectedtourGuideUserId = selectedBooking.tourGuideUserId;


      this.getChatHistory(this.SelectededtouristUserId, this.SelectedtourGuideUserId)
    }
    else {
      this.toasterService.error("Not Selected Booking Properly")
    }
    this.toursection = false
    this.paymentsection = false
    this.messagesection = true
  }



  SetSelectedBooking(item: Booking) {
    this.selectedBooking = { ...item }

  }

  closeBookingOffCanava() {
     
    this.selectedBooking = null
    this.reasonvisiable = false
  }

  getChatHistory(user1Id: number, user2Id: number) {
    this.bookingservice.getAllChatHistory(user1Id, user2Id).subscribe((res) => {
      this.chatHistory = res

    })
  }




  occancelbooking() {
    this.userservice.getreasonforbooking().subscribe((res) => {

      this.getresonofcancel = res


    })
  }
  reasonvisiable: boolean = false
  reasoncancelgo() {
    this.reasonvisiable = true
    this.occancelbooking()
  }

  reasonid: number = 0
  optionalreson: string = ''

  stringreason: string = ''
  getreasonid(reasonId: number, reasonstring: string) {
    this.reasonid = reasonId
    this.stringreason = reasonstring
  }

  cancelbooking() {
     
    this.confirmDialogService.openConfirmDialog('Are you sure you want to cancel this booking? This action will notify the tourist and the guide. Please select a reason to help us improve our services.', () => {
      if (
        typeof this.UserId !== 'number' ||
        typeof this.selectedBooking?.bookingId !== 'number' ||
        typeof this.reasonid !== 'number'
      ) {
        return;

      }

      this.userservice.cancelbookingbyadmin(this.selectedBooking?.bookingId, this.UserId, this.reasonid, this.optionalreson).subscribe((res) => {

        this.toasterService.success("Cancel Booking successfully");


      })
    }, '/assets/confirmation-msg/frame.png')


  }

  sendcancelmailtotourist() {
     
    if (this.selectedBooking?.bookingId === undefined) {

      return;
    }
    this.bookingcanceldetails.bookingId = this.selectedBooking?.bookingId
    this.bookingcanceldetails.cancelledByRole = "Admin"
    this.bookingcanceldetails.reciversName = this.selectedBooking?.touristName
    this.bookingcanceldetails.sendToEmail = this.selectedBooking?.touristEmail
    this.bookingcanceldetails.touristName = this.selectedBooking?.touristName
    this.bookingcanceldetails.tourEndDate = this.selectedBooking?.tourEndDate
    this.bookingcanceldetails.tourstartDate = this.selectedBooking?.tourStartDate
    this.bookingcanceldetails.cancellationReason = this.stringreason
    this.bookingcanceldetails.cancelledOn = new Date().toISOString();
    this.bookingcanceldetails.tourGuideName = this.selectedBooking?.guideName
    this.bookingcanceldetails.tourDestination = this.selectedBooking?.tourLocation
    this.userservice.sendtomailoncancel(this.bookingcanceldetails).subscribe((res) => {




    })
  }



  sendcancelmailtotourguide() {
     
    if (this.selectedBooking?.bookingId === undefined) {

      return;
    }
    this.bookingcanceldetails.bookingId = this.selectedBooking?.bookingId
    this.bookingcanceldetails.cancelledByRole = "Admin"
    this.bookingcanceldetails.reciversName = this.selectedBooking?.touristName
    this.bookingcanceldetails.sendToEmail = this.selectedBooking?.tourGuideEmail
    this.bookingcanceldetails.touristName = this.selectedBooking?.touristName
    this.bookingcanceldetails.tourEndDate = this.selectedBooking?.tourEndDate
    this.bookingcanceldetails.tourstartDate = this.selectedBooking?.tourStartDate
    this.bookingcanceldetails.cancellationReason = this.stringreason
    this.bookingcanceldetails.cancelledOn = new Date().toISOString();
    this.bookingcanceldetails.tourGuideName = this.selectedBooking?.guideName
    this.bookingcanceldetails.tourDestination = this.selectedBooking?.tourLocation
    this.userservice.sendtomailoncancel(this.bookingcanceldetails).subscribe((res) => {




    })
  }



  loadAllUsers() {
     
    this.userservice.getAllUsers(this.searchAll, this.pageAll, this.pageSize, this.roleid)
      .subscribe((res: UsersApiResponse) => {
        this.getuserarr = res.data.items;

        this.totalAll = res.data.totalCount;

        this.totalPages = Math.ceil(this.totalAll / this.pageSize);

        this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);

      });
  }

  originalValues: { [key: string]: any } = {};
  editFields: { [key: string]: boolean } = {
    firstName: false,
    lastName: false,
    email: false
    // Add more keys if needed
  };

  toggleInput(field: string): void {
    this.editFields[field] = !this.editFields[field];
  }

  Togleswitch(): void {
    // Simply turn off all edit flags to hide all input fields
    for (let key in this.editFields) {
      this.editFields[key] = false;
    }
  }

  EditNameFun() {
     

    if (this.getuserid.firstName.trim() === '' || this.getuserid.lastName.trim() === '') {
      this.toasterService.error("First Name and Last Name cannot be empty");
      return;
    }
    this.userservice.Updatename(this.getuserid.firstName, this.getuserid.lastName, this.getuserid.userId).subscribe((res) => {

      this.toasterService.success("User Updated successfully");
      this.getuserid
      this.loadAllUsers()
      this.Togleswitch()
      this.closeBtn2.nativeElement.click();
    })
  }

  isZoomOverlayVisible: boolean = false;
  zoomScale: number = 1;
  zoomedImageUrl: string = '';

  openZoom(url: string) {
    this.zoomedImageUrl = url;
    this.zoomScale = 1;
    this.isZoomOverlayVisible = true;
    document.body.style.overflow = 'hidden'; // Prevent scrolling when zoom is open
  }

  closeZoom() {
    this.isZoomOverlayVisible = false;
    document.body.style.overflow = ''; // Restore scrolling
  }

  zoomIn() {
    if (this.zoomScale < 3) {
      this.zoomScale += 0.25;
    }
  }

  zoomOut() {
    if (this.zoomScale > 0.5) {
      this.zoomScale -= 0.25;
    }
  }

  resetZoom() {
    this.zoomScale = 1;
  }

}
